import React, {useEffect, useRef, useState} from 'react';
import {sendData} from '../../../store/actions';
import {useDispatch} from 'react-redux';
import Layout from '../../../components/layout/Layout';
import {useHistory, useLocation} from "react-router-dom";
import * as Icon from "ubs-icons";
import {isElectron, isMobileDevice} from "../../../common/functions";
import {checkCookie, getCookie} from 'ubs-framework/v2/common/cookie';
import useSocket from "../../common/useSocket";
import UInput from "../../../common/component/UInput";
import Validator from "simple-react-validator"
import {useForceUpdate} from "../../common/useForceUpdate";
import UPopup from "../../../common/component/UPopup";
import AppHeader from "../../common/components/app-header";
import {COLOR} from "../../../common/constant";
import {detectDevice, showToastSuccess} from 'ubs-framework/v2/common/function';
import {withRouter} from "../../../common/hocs/routing-hoc";
import axios from 'axios';

let interval = null
const OTP_TIMEOUT = 30;

function useQuery() {
    const query = new URLSearchParams(useLocation().search);
    const queryParams = {};
    query.forEach((value, key) => {
      queryParams[key] = value;
    });
    return queryParams;
  }

function Login(props) {
    const params = useQuery();
    console.log(`params ::::`, params);
    const dispatch = useDispatch();
    const history = useHistory();
    const CloseModal = useRef("u_select-place");
    const forceUpdate = useForceUpdate();
    const validator = useRef(new Validator({
        element: (message, className) => <div className="u_error_message">{message}</div>,
        autoForceUpdate: {forceUpdate}
    }));

    const [errorMsg, setErrorMsg] = useState("");
    const [disabledBtn, setDisabledBtn] = useState(false);
    const [loginDetail, setLoginDetail] = useState({
        identifier: "",
        password: "",
        platform: detectDevice(true),
    })
    const [hide, setHide] = useState(false)
    const [logoURL, setLogoURL] = useState(localStorage.getItem("selectedLogo") || "");
    const [seconds, setSeconds] = useState(0);

    const {on, off, refresh} = useSocket(res => {
            if (!res.error) {
                switch (res.event) {
                    case 'login':
                        if (res.data.aftrp) history.push("/change-password")
                        else if (res.data.activateAccount) history.push("/verify-email")
                        else if (res?.data?.isCompanyMFA) {
                            setDisabledBtn(false)
                            setSeconds(OTP_TIMEOUT)
                            if(res?.data?.isUserMFASetup) {
                                dispatch({type: 'SET_LOG_IN_DETAILS', payload: {...res?.data, identifier: loginDetail?.identifier, password: loginDetail?.password}})
                                history.push('/multi-factor-authenticate')
                            }
                        }
                        else if (checkCookie('previousURL')) window.location.href = getCookie('previousURL')
                        else {
                            setDisabledBtn(true)
                            history.push("/workspace")
                        }
                        break;
                    default:
                        return true;
                }
            } else {
                setErrorMsg(res.data.error)
                setDisabledBtn(false)
                setTimeout(() => setErrorMsg(res.data.error), 5000)
                if(res?.data?.isCompanyMFA) {
                    if(!res?.data?.isUserMFASetup) {
                        dispatch({type: 'SET_LOG_IN_DETAILS', payload: {...res?.data, identifier: loginDetail?.identifier, password: loginDetail?.password}})
                        history.push('/setup-multi-factor')
                    } else {
                        dispatch({type: 'SET_LOG_IN_DETAILS', payload: {...res?.data, identifier: loginDetail?.identifier, password: loginDetail?.password}})
                        history.push('/multi-factor-authenticate')
                    }
                }
            }
        }
    )

    const onSubmit = (data) => {
        data.preventDefault()
        if (validator?.current?.allValid()) {
            setDisabledBtn(true)
            dispatch({type: 'SET_EMAIL', payload: data});
            if(params?.client_id) {
                const data = {
                    ...loginDetail,
                    email: loginDetail?.identifier
                }
                
                axios.post(`${process.env.REACT_APP_ACCOUNT_SOCKET_URL}/oauth2/login?client_id=${params?.client_id}&state=${params?.state}&redirect_uri=${params?.redirect_uri}&identifier=${params?.identifier}`, data).then(res => {
                    if(res?.data?.data?.redirect_uri) {
                        window.location.href = res?.data?.data?.redirect_uri
                    }
                })
            } else {
                const requestData = JSON.parse(JSON.stringify(loginDetail));
                if (isElectron()) requestData.appVersion = window?.electron?.remote?.app?.getVersion();
                sendData(dispatch, 'login', requestData);
            }
        } else {
            validator?.current?.showMessages()
        }
    }

    const inputEvent = (e) => {
        let {name, value} = e.target;
        value = value.replace(/^\s+/g, '').trim()
        setLoginDetail((val) => {
            return {...val, [name]: value}
        })
    }
    const onKeyUp = e => {
        if (e.key === "Enter") onSubmit(e)
    }

    useEffect(() => {
        const urlSearchParams = new URLSearchParams(window.location.search);
        const params = Object.fromEntries(urlSearchParams.entries());
        if (params.affiliatecode !== undefined) localStorage.setItem('affiliatecode', params.affiliatecode)
        if (params.usercode !== undefined) localStorage.setItem('usercode', params.usercode)
        document?.getElementsByClassName("u_account-form").autofocus;
        refresh()
        return () => off()
    }, [loginDetail])

    useEffect(() => {
        if (seconds === OTP_TIMEOUT) {
            clearInterval(interval)
            interval = setInterval(() => {
                setSeconds(prevState => {
                    if (prevState === 1) {
                        clearInterval(interval)
                        return 0
                    } else return prevState - 1
                })
            }, 1000)
        }
        // return () => clearInterval(interval)
    }, [seconds]);

    return (
        <React.Fragment>
            <Layout module="login">
                {logoURL && (
                    <div className="top-right-logo">
                        <img className="u_logo-top" height={70} width={70} src={logoURL} alt="Logo"/>
                    </div>
                )}
                <div className="u_account-form" ref={CloseModal}>
                    <AppHeader header="Sign In Your Account" title="Welcome Back! Please Sign In to access Superworks."/>
                    <UInput hasError={validator?.current?.message("identifier", loginDetail?.identifier, "required")}
                            className="u_mb-20" label="Email Address / User Name" asterisk>
                        <input onChange={inputEvent} value={loginDetail.identifier} type="text" onKeyUp={onKeyUp}
                               name="identifier" placeholder=" "/>
                    </UInput>
                    <UInput className="u_mb-20" password label="Password" asterisk
                            hasError={validator?.current?.message("password", loginDetail?.password, "required|min:8")}>
                        <input onChange={inputEvent} value={loginDetail.password}
                               type={`${hide ? "text" : "password"}`}
                               autoComplete="off"
                               onKeyUp={onKeyUp}
                               name="password"
                               placeholder=" "/>
                        <div className="u_input-note u_ib">
                            <UPopup params={{className: "u_tooltip u_tooltip-full", disabled: isMobileDevice()}}
                                    desc={<span>{!hide ? "Show Password" : "Hide Password"} </span>}>

                                <span className="u_rollover u_cp u_flex" onClick={() => setHide(!hide)}>{!hide ?
                                    <Icon.HideEye size={18} fill={COLOR.u_icon_bg}/> :
                                    <Icon.Eye size={18} fill={COLOR.u_icon_bg}/>}</span>
                            </UPopup>
                        </div>
                    </UInput>
                    {errorMsg?.length !== 0 && <p className="u_error-message">{errorMsg}</p>}
                    {<div className="u_forgotpass">
                        <span onClick={() => history.push(props?.projectRoutes?.forgot || '/forgot-password')} className="u_forgotpass__link u_cp">Forgot Password?</span>
                    </div>}
                    <div className="u_block u_relative">
                        <button disabled={disabledBtn} type="button" onClick={onSubmit} className={`u_account-btn u_w-full u_cp ${disabledBtn && 'u_white'}`}>Login</button>
                        {disabledBtn && <div className="u_btn-loader"><Icon.Preloader size={70}/></div>}
                    </div>
                </div>
            </Layout>
        </React.Fragment>
    );
}

export default withRouter(Login);
